import { render } from "./IFSOrderLineList.vue?vue&type=template&id=6fb49a01&scoped=true"
import script from "./IFSOrderLineList.vue?vue&type=script&lang=js"
export * from "./IFSOrderLineList.vue?vue&type=script&lang=js"

import "./IFSOrderLineList.vue?vue&type=style&index=0&id=6fb49a01&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fb49a01"]])

export default __exports__